import { Navigate, useLocation } from "react-router";
import queryString from "query-string";
import { UserStorage } from "@certa/common/utils/userStorage";
import { useAuth } from "@certa/auth/AuthenticationProvider";

export const AnonOnlyRouteWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const { csrf } = useAuth();

  const parsedSearchQuery = queryString.parse(location?.search || "");
  const pathname = parsedSearchQuery.next
    ? Array.isArray(parsedSearchQuery.next)
      ? parsedSearchQuery.next[0]
      : parsedSearchQuery.next
    : "/";

  console.log("AnonOnlyRouteWrapper", pathname);

  return UserStorage.getUser() || !!csrf ? (
    <Navigate to={pathname} state={{ from: location }} />
  ) : (
    children
  );
};
